<bs-datepicker-inline
    [bsValue]="currentDate"
    [bsConfig]="{
        dateInputFormat: 'MMMM Do YYYY',
        selectFromOtherMonth: true
    }"
    [minDate]="currentDate"
    [datesDisabled]="[0]"
    (bsValueChange)="onValueChanged($event)"></bs-datepicker-inline>

<timepicker
    [(ngModel)]="selectedDateTime"
    [minuteStep]="1"></timepicker>

<div class="buttons-holder">
    <button
        class="btn-styled--secondary"
        (click)="cancel()">
        Cancel
    </button>
    <button
        class="btn-styled"
        (click)="apply()">
        Apply
    </button>
</div>
